<template>
    <!-- 实施案例详情 -->
    <div class='caseDetail'>
        <!-- 顶部背景 -->
        <div class="top-banner-box">
            <div class="top-banner-img" :style="{ backgroundImage: `url(${headerBgUrl})` }">
            </div>
        </div>
        <!-- 富文本详情 -->
        <div class="caseDetail-text">
            <div class="empty" v-if="Object.keys(info).length == 0">暂无数据</div>
            <div class="caseDetail-text-con" v-html="info.content"></div>
        </div>
    </div>
</template>

<script>
import {
    getHomeCaseDetail
} from "../../utils/interface";
export default {
    name: '',
    components: {},
    props: {},
    data() {
        return {
            headerBgUrl: '',
            info: {} // 富文本内容
        };
    },
    watch: {},
    computed: {},
    created() { },
    mounted() {
        if (this.$route.query.uuid) {
            let uuid = this.$route.query.uuid
            this.getHomeCaseDetail(uuid)
        }
    },
    methods: {
        getHomeCaseDetail(uuid) {
            getHomeCaseDetail(uuid).then(res => {
                if (res.success && Object.keys(res.data).length > 0) {
                    this.info = res.data
                    this.headerBgUrl = res.data.banner
                } else {
                    this.info = {}
                    this.headerBgUrl = ''
                }
            })
        }
    }
};
</script>
<style lang="less" scoped>
.caseDetail {
    position: relative;
    top: -80px;
    margin-bottom: -80px;

    .top-banner-box {
        background-color: #f7f8fb;

        .top-banner-img {
            height: 400px;
            width: 100%;
            overflow: hidden;
            background-repeat: no-repeat;
            background-size: 100% 100%;
            display: flex;
            justify-content: center;
            align-items: center;
        }
    }

    .empty {
        font-size: 24px;
        font-weight: 500;
        color: #5566779e;
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
    }

    .caseDetail-text {
        width: 1300px;
        margin: 0 auto;
        position: relative;

        &-con {
            width: 1280px;
            min-height: 250px;
            border-radius: 16px;
            box-shadow: 0 0 8px #99999947;
            margin: 20px 0;
            box-sizing: border-box;
            padding: 20px 40px;
        }
    }
}

/deep/ .video-js .vjs-big-play-button {
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
}
</style>


// WEBPACK FOOTER //
// src/components/newHome/caseDetail.vue